export const logoutHandler = async (): Promise<boolean> => {
  localStorage.setItem('loggedIn', 'false')
  window.location.assign('/login')
  return true
}
